import { enUS, es, pt, ptBR, type Locale } from 'date-fns/locale';
import type { PublicSurveyLanguage } from './index';

const DATE_LOCALES: Record<PublicSurveyLanguage, Locale> = {
  'pt-BR': ptBR,
  'pt-PT': pt,
  en: enUS,
  es,
};

export function getPublicSurveyDateLocale(language: string): Locale {
  if (language in DATE_LOCALES) {
    return DATE_LOCALES[language as PublicSurveyLanguage];
  }
  return ptBR;
}
